<template>
  <b-card>
    <FormBuilder
      label="Kategori Utama"
      create
      :fields="fields"
      :loading-submit="$store.state.rootCategory.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/root-category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('rootCategory/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
